import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["siteGroup", "siteCheckbox", "warning"]
  static values = { authorizedAccountIds: Array }

  connect() {
    this.updateSites()
  }

  updateSites() {
    const selectedAccountId = this.element.querySelector("[name=account_id]").value

    this.siteGroupTargets.forEach((group) => {
      const visible = group.dataset.accountId === selectedAccountId
      group.classList.toggle("hidden", !visible)

      if (!visible) {
        group.querySelectorAll("input[type=checkbox]").forEach((cb) => {
          cb.checked = false
        })
      } else {
        const existingSiteIds = JSON.parse(group.dataset.existingSiteIds || "[]")
        group.querySelectorAll("input[type=checkbox]").forEach((cb) => {
          cb.checked = existingSiteIds.includes(cb.value)
        })
      }
    })

    if (this.hasWarningTarget) {
      const hasExistingToken = this.authorizedAccountIdsValue.includes(selectedAccountId)
      this.warningTarget.classList.toggle("hidden", !hasExistingToken)
    }
  }
}
